import { API_BASE_URL } from '@/lib/api/client';
import type { AdPlacement } from '@/lib/services/store.service';

/** O que a API aceita por pedido. */
const MAX_POR_LOTE = 5;
const ESPERA_MS = 1500;

type Exibicao = { campaignId: string; placement: AdPlacement };

let fila: Exibicao[] = [];
let lojaDaFila: string | null = null;
let timer: ReturnType<typeof setTimeout> | null = null;

function enviar() {
  if (timer) clearTimeout(timer);
  timer = null;
  const loja = lojaDaFila;
  while (loja && fila.length > 0) {
    const items = fila.splice(0, MAX_POR_LOTE);
    // `keepalive`: o pedido sai mesmo se a pessoa trocar de página no meio.
    fetch(`${API_BASE_URL}/public/ads/impressions`, {
      method: 'POST',
      keepalive: true,
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ storeId: loja, items }),
    }).catch(() => undefined);
  }
}

if (typeof window !== 'undefined') {
  window.addEventListener('pagehide', enviar);
}

/**
 * Junta as exibições da página e manda em lote. A API conta uma vez por pessoa
 * a cada 30 minutos e só para campanha que a loja pode mostrar.
 */
export function registrarExibicao(storeId: string, campaignId: string, placement: AdPlacement) {
  if (lojaDaFila && lojaDaFila !== storeId) enviar();
  lojaDaFila = storeId;
  if (fila.some((e) => e.campaignId === campaignId && e.placement === placement)) return;
  fila.push({ campaignId, placement });
  if (fila.length >= MAX_POR_LOTE) return enviar();
  if (!timer) timer = setTimeout(enviar, ESPERA_MS);
}
